import axios from 'axios';
import { Sliders } from './Sliders';

/** ----------------------------------------
    Map Filter
 ---------------------------------------- */

export class MagazineFilter {

    // ---------------------------------
    // Constructor
    // ---------------------------------

    constructor() {
        this.containerEl = document.querySelector('.magazine-overview');

        if (!this.containerEl)
            return;

        this.resetButtonEl = document.querySelector('#js-reset');
        this.formatFilterEls = document.getElementById('format-filter').getElementsByTagName('input');
        this.gridEl = document.getElementById('magazine-results');
        this.countEl = document.getElementById('header-count')
        this.loaderEl = document.querySelector('#magazine-loader');
        this.format = '';

        this._init();
    }

    // ---------------------------------
    // Fetch magazines
    // ---------------------------------

    _fetchMagazines() {
        axios.get(`/api/magazines?format=${ this.format }`)
            .then(response => {
                this.gridEl.innerHTML = response.data.dom;

                this.countEl.innerHTML = `(${ response.data.count })`;

                new Sliders();
            });
    }

    // ---------------------------------
    // Handle format filter
    // ---------------------------------

    _setFormatFilterEvents() {
        for (let i = 0; i < this.formatFilterEls.length; i++) {
            this.formatFilterEls[i].addEventListener('change', () => {
                this.format = this.formatFilterEls[i].value;
                this.page = 0;
                this._fetchMagazines();
            });
        }
    }

    // ---------------------------------
    // Reset filter
    // ---------------------------------

    _resetFilter() {
        const url = window.location.href;

        this.resetButtonEl.addEventListener('click', () => {
            window.location.replace(url);
        });
    }

    // ---------------------------------
    // Init
    // ---------------------------------

    _init() {
        this._setFormatFilterEvents();
        this._resetFilter();
    }
}